import queryString from 'query-string';

import type { GeneratedMedia } from '~entities/media';

const apiBase = process.env.PUBLIC_API ?? 'https://api.ifriend.ai';

type GetMediaPublicApiRequest = {
	page?: number;
};

type GetMediaPublicApiResponse = {
	media: GeneratedMedia[];
	totalPages: number;
};

const DAY_HALF = 60 * 60 * 12;

export const getMedia = async ({
	page,
	request,
}: {
	page: number;
	request?: RequestInit;
}) => {
	const query: GetMediaPublicApiRequest = {
		page,
	};

	const searchQuery = queryString.stringify(query);
	const response = await fetch(
		`${apiBase}/ai/generation/media/public?${searchQuery}`,
		{
			...request,
			next: {
				revalidate: DAY_HALF,
				...request?.next,
				tags: ['gallery'],
			},
		}
	);

	if (!response.ok) {
		throw new Error(`Error fetching grid: ${response.status}`);
	}

	const json = (await response.json()) as GetMediaPublicApiResponse;

	return {
		media: prepareMedia(json.media),
		totalPages: json.totalPages,
	};
};

export function prepareMediaItem(item: GeneratedMedia) {
	const { imageLinks, mediaLinks, type, ...rest } = item as GeneratedMedia & {
		imageLinks?: unknown;
	};

	return {
		type: type || (imageLinks ? 'image' : 'video'),
		mediaLinks: imageLinks || mediaLinks,
		isPublic: item.additionalOptions?.isPublic ?? false,
		...rest,
	} as GeneratedMedia;
}

export function prepareMedia(media: GeneratedMedia[]) {
	return media.map((it) => prepareMediaItem(it));
}
